export default "__VITE_ASSET__CbLNzz5M__"